import {  SurveyEngine_Models_Answer, SurveyEngine_Models_BaseResponse, SurveyEngine_Models_DynamicResponseResponse, SurveyEngine_Models_GetResponseResponse, } from '../../../api'
import { GetResponse } from '../GetResponse/GetResponse';
import { GetResponseAnswerData } from '../../../Common/Commands';

interface DynamicResponseProps {
  id: number,
  question: string,
  commandType: string
  answers: SurveyEngine_Models_Answer[],
  defaultAnswer: string,
  layout: string,
  isError: boolean,
  focus: boolean,
  callback: (response: SurveyEngine_Models_BaseResponse) => void
}


export const DynamicResponse = (props: DynamicResponseProps) => {

  const transformResponse = (response: SurveyEngine_Models_GetResponseResponse) => {

    if (response) {
      let res: SurveyEngine_Models_DynamicResponseResponse = {
        commandIndex: response.commandIndex,
        //should not override if command type is "Remove"
        commandType: response.commandType?.toLocaleLowerCase() === 'remove' ? "Remove" : "DynamicResponse",
        selectedId: response.selectedId
      }
      props.callback(res);
    }

  }

  const transformAnswers = () => {

    let data: GetResponseAnswerData[] = props.answers.map(
      (item: SurveyEngine_Models_Answer) => {

        let answer: GetResponseAnswerData = {
          label: item.message!,
          value: item.id!,
          isOpenEnded: false,
          otherValue: ""
        }
        return answer;
      });
    return data;
  }

  return (
    <GetResponse id={props.id!}
      question={props.question!}
      answers={transformAnswers()}
      defaultAnswer={props.defaultAnswer}
      layout={props.layout}
      isError={props.isError}
      callback={transformResponse}
      focus={props.focus}
    />
  )
}
